{
  "DATA_ASSISTANT": {
    "TITLE": "Veri Asistanı",
    "NEW_CONVERSATION": "+ Yeni",
    "LOADING": "Yükleniyor...",
    "LOADING_MESSAGES": "Mesajlar yükleniyor...",
    "THINKING": "Düşünüyor...",
    "UNTITLED": "Başlıksız sohbet",
    "NO_CONVERSATIONS": "Henüz sohbet yok. Başlamak için \"+ Yeni\"ye tıklayın.",
    "EMPTY_STATE": "Başlamak için bir sohbet seçin veya yeni bir tane oluşturun.",
    "PLACEHOLDER": "Sizin için ne bulabilirim?",
    "SHOW_SQL": "SQL'i Göster",
    "NO_ROWS": "Hiç satır dönmedi.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Sohbeti sil",
    "DELETE_CONFIRM_DESCRIPTION": "Bu sohbeti silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    "DELETE_CONFIRM_YES": "Sil",
    "REPORTS": "Raporlar",
    "SAVE_TO_REPORT": "Rapora kaydet",
    "NEW_REPORT": "Yeni rapor",
    "REPORT_NAME": "Rapor adı",
    "NO_REPORTS": "Henüz kaydedilmiş rapor yok",
    "REPORTS_EMPTY_STATE": "Bir rapor seçin veya yeni bir tane oluşturun.",
    "REPORT_SAVED": "Rapora kaydedildi",
    "DELETE_REPORT_CONFIRM": "Raporu sil",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Bu raporu silmek istediğinizden emin misiniz? Kaydedilmiş tüm öğeler kaldırılacaktır.",
    "DELETE_ITEM_CONFIRM": "Öğeyi kaldır",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Bu öğeyi rapordan kaldırmak istediğinizden emin misiniz?",
    "EXPORT_CSV": "CSV Olarak Dışa Aktar",
    "REFRESH": "Yenile",
    "QUERY_RUNNING": "Sorgu çalıştırılıyor...",
    "QUERY_FAILED": "Sorgu başarısız oldu",
    "AUTO_REFRESH": "Otomatik yenileme",
    "AUTO_REFRESH_NONE": "Manuel",
    "AUTO_REFRESH_30S": "30 saniye",
    "AUTO_REFRESH_1M": "1 dakika",
    "AUTO_REFRESH_5M": "5 dakika",
    "AUTO_REFRESH_10M": "10 dakika",
    "EDIT_MESSAGE": "Mesajı düzenle",
    "RENAME_REPORT": "Raporu yeniden adlandır",
    "RENAME_ITEM": "Öğeyi yeniden adlandır",
    "MOVE_UP": "Yukarı taşı",
    "MOVE_DOWN": "Aşağı taşı",
    "COLLABORATORS": {
      "BUTTON": "Ortak Çalışanlar",
      "TITLE": "Rapor ortak çalışanları",
      "DESCRIPTION": "Bu raporu hangi temsilcilerin ve takımların görebileceğini seçin.",
      "AGENTS": "Temsilciler",
      "TEAMS": "Takımlar",
      "SELECT_AGENTS": "Temsilcileri seçin",
      "SELECT_TEAMS": "Takımları seçin",
      "SAVE": "Kaydet",
      "SAVED": "Ortak çalışanlar güncellendi",
      "SAVE_FAILED": "Ortak çalışanlar güncellenemedi"
    }
  }
}
